import React, { useEffect, useState } from "react";
import {
  Toast,
  Userlogin,
  formatRupee,
  formateNumberStNdRd,
  handleGetApiGF,
  handlePostApiGF,
} from "../Utils/general-function";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import RemainingPageTitle from "../Utils/RemainingPageTitle";
import NoCars from "../Utils/NoCars";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollButton from "../Utils/scrollbutton";

// advance filter
import blackheart from "../../src_img/blackheart.png";
import redheart from "../../src_img/redheart.png";
function CustomerCarWishlists() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [allFavCars, setAllFavCars] = useState([]);

  const fetchAllFavCars = async () => {
    const res = await handleGetApiGF({
      url: "/api/DealerFavouriteVehicle/AllFavouritecars",
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Something went wrong!");
      setLoading(false);
      return;
    }
    setAllFavCars(res?.data?.Data || []);
    setLoading(false);
  };

  const removeCarWishlist = async (data) => {
    setLoading(true);
    const { carnumber, carid } = data || {};
    console.log("carid", carid);

    // actiondata(Add/Delete)
    let obj = {
      actiondata: "Delete",
      carnumber,
      carid,
    };
    const res = await handlePostApiGF({
      url: "/api/DealerFavouriteVehicle/addfavouritecars",
      obj,
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Something went wrong");
      setLoading(false);
      return;
    }
    await fetchAllFavCars();
    Toast(
      res?.succ,
      res?.msg || "Successful",
      res?.msg || "Something went wrong",
    );

    console.log("res add remove wishlist", res);
  };
  useEffect(() => {
    fetchAllFavCars();
  }, []);
  console.log("allFavCars", allFavCars);

  return (
    <div>
      <Header />
      <div className="text-center">
        <h2 className="page-title">Wishlisted Car</h2>
      </div>

      <div className="page-space" style={{ marginBottom: "50px" }}>
        {loading && <Loader />}
        {allFavCars.length === 0 && !loading ? (
          <>
            <NoCars
              mainMsg=""
              msg="Your wishlist is empty. Start adding your favorite cars!"
            />
            <div className="w-100 text-center">
              <Link to={"/customercarlist"} className="submitbtn">
                See All Cars
              </Link>
            </div>
          </>
        ) : (
          allFavCars.map((data, i) => (
            <div className="car-div mt-4" key={data.Rand}>
              <div className="car-radius">
                <div className="position-relative">
                  <img
                    src={redheart}
                    style={{ position: "absolute", right: "10px", top: "10px" }}
                    alt=""
                    onClick={() => removeCarWishlist(data)}
                  />
                  <img src={data.carphoto} className="w-100" alt="" />
                </div>
                <div className="car-smdetails">
                  <span className="abs-span">{data.fueltypeid}</span>
                  <RemainingPageTitle dataFromParent={data} />

                  <div className="car-km justify-content-start gap-2 flex-wrap">
                    <>
                      <div className="d-flex align-items-center">
                        <img src="assets/images/car-num.svg" alt="" />
                        <span>{data.carnumber}</span>
                      </div>
                      {data.km && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/car-km.svg"
                            alt=""
                            // className="ms-2"
                          />
                          <span>
                            {formatRupee({ amt: data.km, rupeeIcon: false })}
                          </span>
                        </div>
                      )}
                      {data.Carage && (
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 357.102 357.102"
                            // className="ms-2"
                          >
                            <g>
                              <path
                                d="M192.349 13.8c-90.484 0-164.387 73.614-164.741 164.096..."
                                fill="#ff002a"
                              ></path>
                              <path
                                d="M186.553 98.752c-8.284 0-15 6.716-15 15v63..."
                                fill="#ff002a"
                              ></path>
                            </g>
                          </svg>
                          <span>{data.Carage} days</span>
                        </div>
                      )}

                      {data.nCity && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/address.png"
                            height={21}
                            width={21}
                            alt="address"
                            // className="ms-2"
                          />
                          <span>
                            {data.nCity}, {data.nState}
                          </span>
                        </div>
                      )}
                      {/* <div className="d-flex align-items-center">
                        <span className="material-symbols-outlined fs-2 p-0">
                          person
                        </span>
                        <span>{formateNumberStNdRd(data?.owner)} Owner</span>
                      </div> */}
                    </>
                  </div>
                </div>
                <div className="two-btns">
                  <Link
                    to={`/customercardetail/${data?.Rand}`}
                    state={{ details: data }}
                    className="w-100 lightRedBtn"
                    style={{ borderRadius: "0 0 10px 10px" }}
                  >
                    More Details
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}

        {/* <InfiniteScroll
          dataLength={resultsContxt.length}
          next={loadMoreCars}
          hasMore={hasMore}
          // loader={<Loader />}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
        /> */}

        <ScrollButton />
      </div>
    </div>
  );
}

export default CustomerCarWishlists;
